import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/apiClient";
import GoogleSignInButton from "@/components/GoogleSignInButton";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      nav(u.role === "super_admin" ? "/admin/super" : u.role === "business_admin" ? "/business" : "/admin/salon");
    } catch (err) {
      toast.error(apiErr(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.pexels.com/photos/16571735/pexels-photo-16571735.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Clinic" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2C3531]/60" />
        <div className="absolute bottom-10 left-10 text-white">
          <div className="flex items-center gap-2 mb-3"><Sparkles className="w-6 h-6" /><span className="font-serif text-2xl font-bold">Grow Your Bookings</span></div>
          <p className="text-white/80 max-w-xs">The operating system for multi-location aesthetics businesses.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 bg-[#FDFBF7]">
        <motion.form initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} onSubmit={submit}
          className="w-full max-w-sm" data-testid="login-form">
          <h1 className="font-serif text-3xl font-bold mb-1">Sign in</h1>
          <p className="text-sm text-[#787672] mb-8">Super admin & salon portals.</p>
          <div className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-11" placeholder="you@salon.com" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 h-11" placeholder="••••••••" />
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full mt-6 h-11 rounded-full bg-[#2C3531] hover:bg-[#1e2422] font-semibold active:scale-95 transition-transform">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </Button>
          <div className="flex items-center gap-3 my-5">
            <span className="h-px flex-1 bg-[#E8E6E1]" /><span className="text-xs text-[#9A8C73]">or</span><span className="h-px flex-1 bg-[#E8E6E1]" />
          </div>
          <GoogleSignInButton />
        </motion.form>
      </div>
    </div>
  );
}
